import { createContext } from 'react'

const DescendantOfMapContext = createContext(false)

export default DescendantOfMapContext
